import {
  IonGrid, IonRow, IonButton, IonLabel, IonCheckbox, useIonAlert,
} from '@ionic/react'
import { Icon } from '@iconify/react'
import { Dropdown } from 'react-bootstrap'
import * as React from 'react'
import { useRiskRegister } from '../../hooks/risks/useRiskRegister'
import {
  Views, ListModes, Filters, FocusedActionKind, DisplayAssetAction, ViewsActionKind,
} from '../../hooks/risks/helpers/StateReducers'
import useApi from '../../hooks/testHooks'
import { downloader } from './forms/utils/RiskAssessmentCalculations'
import { useWorkspace } from '../../hooks/useWorkspace'
import { SelectView } from '../maps/StyledContainers'
import { ConsultantFilter } from '../consultant/StyledContainers'
import { AppView } from '../../hooks/risks/types/HookInterfaces'

/**
 *  ==========================================
 *          RISK ASSESSMENT MAP CONTROLS
 *  ======================================s====
 */
const MapControlsV2 = () : JSX.Element => {
  /* import hook data */
  const {
    viewMode, dispatchViews, displayAsset, dispatchRisk, filterMarkersByState, toggleAllAssets, setView, setShowAssetForm, showAssetForm,
    editing, filters, dispatchAsset, setEditing, dispatchDisplayAsset, focusedAsset, forgetEditingAsset, view, selectedAsset,
    setShowMapFilterPopup,
  } = useRiskRegister()
  const [ionAlert] = useIonAlert()
  const apiHook = useApi()
  const { workspace } = useWorkspace()

  /* How many states have been selected in the dropdown */

  /** handle view changes between map and lists */
  const handleViewChange = (e: React.FormEvent<HTMLSelectElement>) : void => {
    setEditing(false)
    dispatchAsset({ type: FocusedActionKind.FORGET })
    dispatchRisk({ type: FocusedActionKind.FORGET })
    dispatchDisplayAsset(DisplayAssetAction.CLOSE_ALL)

    if (e.currentTarget.value === Views.MAP_VIEW) {
      dispatchViews({ type: ViewsActionKind.MAP_VIEW })
    } else {
      dispatchViews({ type: ViewsActionKind.LIST_ASSETS })
    }
  }

  const handleDownload = (risk: boolean) => {
    if (risk) {
      apiHook.downloadRisks({
        domain_id: workspace.id,
        asset_id: focusedAsset.id, // changed to focused asset
      })
        .then((data) => {
          downloader(data, 'Risk Register.xlsx')
        })
    } else {
      apiHook.downloadAssets({
        domain_id: workspace.id,
      })
        .then((data) => {
          downloader(data, 'Asset Register.xlsx')
        })
    }
  }

  //

  return (
    <IonGrid
      style={{
        backgroundColor: '#FFFFFF',
        padding: '10px 30px',
        marginBottom: '25px',
        boxShadow: '0px 4px 4px 0px #00000040',
        position: 'relative',
        borderRadius: '5px',
      }}
      className='insight-controls-bar'
    >
      <IonRow className='ion-align-items-center ion-justify-content-between'>
        <IonRow className='ion-align-items-center'>
          <SelectView
            value={viewMode.view}
            onChange={handleViewChange}
            disabled={displayAsset.showAssetForm || editing}
            id='select-app-view'
          >
            <option value={Views.MAP_VIEW}>Asset Map</option>
            <option value={Views.REGISTER_VIEW}>Asset Register</option>
          </SelectView>
          {
            viewMode.view === Views.REGISTER_VIEW && viewMode.listMode === ListModes.RISKS && (
              <IonButton
                style={{ '--ion-color-primary': '#326771' }}
                onClick={() => dispatchViews({ type: ViewsActionKind.LIST_ASSETS })}
                id='risk-register-back-button'
              > <Icon icon='akar-icons:arrow-back' /> Back
              </IonButton>
            )
          }
        </IonRow>
        <IonRow className='ion-align-items-center'>
          {
            viewMode.view === Views.REGISTER_VIEW && viewMode.listMode === ListModes.RISKS && (
              <>
                {
                  !editing && (
                    <IonButton
                      style={{ '--ion-color-primary': '#0C9500' }}
                      id='add-risk-assessment-button'
                      onClick={() => {
                        dispatchDisplayAsset(DisplayAssetAction.OPEN_RISK_FORM)
                        dispatchDisplayAsset(DisplayAssetAction.OPEN_ASSET_FORM)
                      }}
                    >Add Risk
                    </IonButton>
                  )
                }
                <IonButton
                  style={{ '--ion-color-primary': '#326771' }}
                  onClick={() => setEditing(!editing)}
                  disabled={displayAsset.showAssetForm}
                >
                  {(editing) ? 'Done' : 'Edit/Review'}
                </IonButton>
              </>
            )
          }
          {
            viewMode.view === Views.REGISTER_VIEW && viewMode.listMode === ListModes.ASSETS && (
              <IonButton style={{ '---background': '#FFFFFF', '--ion-color-primary': '#FFFFFF' }} onClick={() => handleDownload(false)}>
                <p style={{ margin: '0', fontSize: '12px', color: 'black' }}><Icon icon='vscode-icons:file-type-excel' inline />Download Asset Register</p>
              </IonButton>
            )
          }
          {
          viewMode.view === Views.MAP_VIEW && (
            <>
              <IonButton onClick={() => setShowMapFilterPopup(true)} style={{ '--background': '#326771' }}>Map Filters<Icon icon='fa:filter' /></IonButton>
              <IonButton
                style={{ '--ion-color-primary': '#0C9500' }}
                onClick={() => setShowAssetForm(true)}
                disabled={showAssetForm}
                id='add-asset-button'
              >Add Asset
              </IonButton>
            </>
          )
        }
        </IonRow>
      </IonRow>

    </IonGrid>
  )
}

export default MapControlsV2
